export default {
  COMMISSIONED: 'Beställd',
  CONFIRMED: 'Bekräftad'
}
